// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from '/root/workspace/fe-cms-web_r8zx/src/app.tsx';
import * as Plugin_1 from '../plugin-initial-state/runtime';
import * as Plugin_2 from '../plugin-model/runtime';
import * as Plugin_3 from '/root/workspace/fe-cms-web_r8zx/src/.umi-production/plugin-helmet/runtime.ts';

  plugin.register({
    apply: Plugin_0,
    path: '/root/workspace/fe-cms-web_r8zx/src/app.tsx',
  });
  plugin.register({
    apply: Plugin_1,
    path: '../plugin-initial-state/runtime',
  });
  plugin.register({
    apply: Plugin_2,
    path: '../plugin-model/runtime',
  });
  plugin.register({
    apply: Plugin_3,
    path: '/root/workspace/fe-cms-web_r8zx/src/.umi-production/plugin-helmet/runtime.ts',
  });

export const __mfsu = 1;
